// version of app is automatically added to the build and login request. it is calculated in the build script and saved in src/versioning/version.js
export const getOrigin = () => {
  if (window.api) {
    const origin = "https://www.ljelogbooks.com";
    // const origin = "https://www.ljelogbooks.com/";
    return origin;
  } else if (window.location.origin.includes("localhost")) {
    return "http://localhost/";
    // return "https://www.ljelogbooks.com";
    // return "https://www.ljelogbooks.com/";
  } else {
    // Changed to strip port numbers from url so we can use IP:PORT for the FE and IP no port for BE.
    // this resolves an issue were we are running LAN setups using IPs rather than localhost
    return window.location.protocol + "//" + window.location.hostname;
  }
};

export const getApiUrl = () => `${getOrigin()}/api/v1/main.php`;

export const getSentry = () => {
  if (window.api) {
    // DEV
    // return "https://6a385ec4d908c1570af60eaf85dbf405@o4507254749396992.ingest.de.sentry.io/4507271090667600";
    // TEST
    // return "https://bdf18aaa2979729a14647242807f99a5@o4507254749396992.ingest.de.sentry.io/4507271119110224"
    // LIVE
    return "https://e9c67a2363529422dd664e3d9c513116@o4507254749396992.ingest.de.sentry.io/4507271127760976";
  } else if (window.location.origin.includes("localhost")) {
    return "";
    // return "https://3f4e2894297cad5c965708ec74a2b255@o4507254749396992.ingest.de.sentry.io/4507271139033168";
  } else {
    if (window.location.origin === "https://www.ljelogbooks.com") {
      return "https://3f4e2894297cad5c965708ec74a2b255@o4507254749396992.ingest.de.sentry.io/4507271139033168";
    } else if (window.location.origin === "https://test.ljelogbooks.com") {
      return "https://101f93cb7da367416eac502b06ac522f@o4507254749396992.ingest.de.sentry.io/4507271141064784";
    } else if (window.location.origin === "https://www.ljelogbooks.com")
      return "https://cdaaa2ea4632ce3213cbccd5a914b545@o4507254749396992.ingest.de.sentry.io/4507271142768720";
  }
};
